import {
  Box,
  Flex,
  Heading,
  HStack,
  Select,
  Spinner,
  Stack,
  Tooltip,
  useDisclosure,
  useMediaQuery,
  useToast,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { AiOutlineInfoCircle } from 'react-icons/ai'

import { BarChartComponent } from '../../../components/data/BarChartComponent'
import { AccessModal } from '../../../components/widgets/AccessModal'
import { apiSensedia } from '../../../services/api-sensedia'

export const Production = () => {
  const [isLargerThan800] = useMediaQuery('(max-width: 800px)')
  const toast = useToast()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [isLoading, setIsLoading] = useState(false)

  const chartLabels = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ]

  const [selectedProduct, setSelectedProduct] = useState('SAUDE PME')

  const [chartData, setChartData] = useState([
    {
      label: 'Ano anterior',
      data: [],
      color: '#146CFA',
      show: false,
    },
    {
      label: 'Ano atual',
      data: [],
      color: '#FF8C00',
      show: true,
    },
  ])

  const httpGetMonthlySales = async (product = 'SAUDE PME') => {
    try {
      setIsLoading(true)

      const params = {
        product: product,
        year: new Date().getFullYear(),
        start_month: 1,
        end_month: 12,
      }
      const { data: currentYear } = await apiSensedia.get('/assessorias/producoes', {
        params,
      })

      params.year = new Date().getFullYear() - 1
      const { data: lastYear } = await apiSensedia.get('/assessorias/producoes', {
        params,
      })

      setChartData([
        {
          label: 'Ano anterior',
          data: lastYear.sales.map(v => v.premio_emitido),
          color: '#146CFA',
          show: true,
        },
        {
          label: 'Ano atual',
          data: currentYear.sales.map(v => v.premio_emitido),
          color: '#FF8C00',
          show: true,
        },
      ])
    } catch (error: any) {
      console.log(error)

      if (error?.response?.status === 401) {
        onOpen()
        return
      }

      toast({
        position: 'top',
        description: error.response?.data,
        status: 'error',
        duration: 4000,
        isClosable: true,
      })
    } finally {
      setIsLoading(false)
    }
  }

  const handleSelectProduct = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedProduct(event.target.value)

    httpGetMonthlySales(event.target.value)
  }

  useEffect(() => {
    httpGetMonthlySales()
  }, [])

  return (
    <Flex w="100%" maxW="79vw" justify="center" align="center">
      {isLoading ? (
        <Spinner />
      ) : (
        <Box
          boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
          borderRadius="24px"
          width="100%"
          p="20px"
          color="#001E64"
          bg="#fff"
          position="relative"
        >
          <HStack w="100%" justify="space-between" flexDir={{ base: 'column', md: 'row' }} gap="1rem">
            <Stack>
              <HStack>
                <Heading fontSize="1.4rem">Produção</Heading>

                <Tooltip label="Quantidade de prêmios emitidos mensalmente e anualmente." shouldWrapChildren>
                  <AiOutlineInfoCircle size={20} />
                </Tooltip>
              </HStack>
            </Stack>

            <HStack
              flexDir={{ base: 'column', md: 'row' }}
              gap="1rem"
              w={{ base: '100%', sm: 'fit-content', md: 'fit-content' }}
            >
              <Select
                borderRadius="24px"
                border="1px solid #001E64 !important"
                h="3.125rem"
                w={{ base: '100%', sm: '12.5rem', md: '12.5rem' }}
                p="13px, 47px, 13px, 47px"
                value={selectedProduct}
                onChange={e => handleSelectProduct(e)}
              >
                <option value="SAUDE PME">Saúde PME</option>
                <option value="SAUDE GRUPAL EMPRESARIAL">Saúde empresarial</option>
                <option value="ODONTO INDIVIDUAL">Odonto individual</option>
                <option value="ODONTO EMPRESARIAL">Odonto empresarial</option>
                <option value="ODONTO PME">Odonto PME</option>
                <option value="VIDA INDIVIDUAL">Vida individual</option>
                <option value="VIDA GRUPAL">Vida coletivo</option>
                <option value="CONT INDIVIDUAL MEN">Previdência individual</option>
              </Select>
            </HStack>
          </HStack>

          <Box
            background={'#2A4E9A'}
            color={'#fff'}
            width={'fit-content'}
            padding={'0 0.5rem'}
            borderRadius={'0.5rem'}
            margin={isLargerThan800 ? '0 auto' : '0'}
            marginTop={'1.3rem'}
          >
            Por favor, passar o mouse no gráfico para visualizar sua produção
          </Box>

          <BarChartComponent title="" labels={chartLabels} datasets={chartData.filter(item => item.show === true)} />
        </Box>
      )}
      <AccessModal isOpen={isOpen} onClose={onClose} />
    </Flex>
  )
}
